import { Reveal } from "@/components/Reveal";

export function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <section data-testid="page-header" className="relative pt-32 pb-14 bg-brand-navy overflow-hidden">
      <div className="absolute inset-0 grain opacity-30" />
      <div className="absolute -top-24 right-0 h-72 w-72 rounded-full bg-brand/30 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          {eyebrow && <p className="text-xs uppercase tracking-[0.18em] font-bold text-brand-sky">{eyebrow}</p>}
          <h1 className="mt-3 font-heading font-light text-4xl sm:text-5xl tracking-tight text-white text-balance">{title}</h1>
          {subtitle && <p className="mt-4 text-white/70 max-w-2xl text-base leading-relaxed">{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}
